<div class="container-fluid custom-header-wrapper">
    <div class="custom-header-content" [class]="customStyle">
        <img src="/image-service/ws/imgs/file/5294728/aws/w/0/h/0.img" alt="Usana">
        <h1 class="heading-3" translate="cart.{{titleTag}}.header.title"></h1>
    </div>
</div>
